import React, { useState } from "react";
import { Form } from "react-bootstrap";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";

interface Props {
	controlId: string;
	options: any;
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	selectedOption: any;
}

const BtfOptionGroup: React.FC<Props> = (props) => {
	const { controlId, onChange, selectedOption, options } = props;

	const [radioValue, setRadioValue] = useState(selectedOption);

	const handleTipoCodiceChange = (event: any) => {
		setRadioValue(event.target.value);
		onChange(event);
	};

	return (
		<Form.Group controlId={controlId}>
			<ButtonGroup className="flex-wrap mb-2">
				{options.map((option: any, idx: any) => (
					<ToggleButton
						key={idx}
						id={`radio-${idx}`}
						type="radio"
						className="bft-toggle-button"
						variant={`radio ${option.value === radioValue ? "checked" : ""}`}
						name="radio"
						value={option.value}
						checked={selectedOption === option.value}
						onChange={handleTipoCodiceChange}
					>
						{option.icon && <i className={`fas fa-${option.icon} me-2`}></i>}
						{option.label}
					</ToggleButton>
				))}
			</ButtonGroup>
		</Form.Group>
	);
};

export default BtfOptionGroup;
